import { administrationRequests } from "api/administrationApi";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import { resolveErrorMessage } from "utils/useNotifyError";

const checkAvailability = async ({
  campaignId,
  startDate,
  endDate,
  degreeId,
  directionId,
  citizenshipIds,
  typeId,
  notify,
}) => {
  if (!typeId || !directionId) {
    return;
  }

  const isAvailable = await getCampaignAvailabilityRequest({
    typeId,
    directionId,
    startDate,
    endDate,
    campaignId,
    degreeId,
    citizenshipIds,
    notify,
  });
  if (!isAvailable) {
    return "Вече има стартирана кампания за този период!";
  }
};

const getCampaignAvailabilityRequest = async ({
  typeId,
  directionId,
  startDate,
  endDate,
  campaignId,
  degreeId,
  citizenshipIds,
  notify,
}) => {
  const queryParams = new URLSearchParams({
    typeId: typeId,
    directionId: directionId,
    registrationFrom: startDate,
    registrationTo: endDate,
  });

  if (campaignId) {
    queryParams.append("campaignId", campaignId);
  }
  if (degreeId) {
    queryParams.append("degreeId", degreeId);
  }

  citizenshipIds.forEach(citizenshipId => {
    if (citizenshipId) {
      queryParams.append("citizenshipIds", citizenshipId);
    }
  });

  try {
    const { data } = await dataProvider.customRequest(
      candidateRequests.getCampaignAvailabilitySelect(),
      null,
      "GET",
      `?${queryParams.toString()}`,
    );
    return data === "true" ? true : data === "false" ? false : data;
  } catch (error) {
    notify(resolveErrorMessage(error), { type: "error" });
    return false;
  }
};

const getSpecialitiesDistribution = async specialityIds => {
  if (!specialityIds?.length) return [];
  try {
    const { data } = await dataProvider.customRequest(
      administrationRequests.getSpecialityGenderDistributionByIds(specialityIds),
      null,
      "GET",
    );

    return data;
  } catch (error) {
    console.error("Error fetching specialities distribution:", error);
    return [];
  }
};

const campaignHelper = {
  checkAvailability,
  getSpecialitiesDistribution,
};

export default campaignHelper;
